import { lazy } from 'react';

// Public routes
export const publicRoutes = {
  home: '/',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  pricing: '/pricing',
  about: '/about',
  contact: '/contact',
} as const;

// App routes (Admin Company, Custom Role, Member)
export const appRoutes = {
  dashboard: '/app/dashboard',
  // Company
  companyProfile: '/app/company/profile',
  companyDepartments: '/app/company/departments',
  companyPolicies: '/app/company/policies',
  companyLeavePolicies: '/app/company/leave-policies',
  companyPayCycles: '/app/company/pay-cycles',
  companyRequestTypes: '/app/company/request-types',
  // Employees
  employees: '/app/employees',
  employeesDetail: (id: string) => `/app/employees/${id}`,
  employeesInvite: '/app/employees/invite',
  employeesImport: '/app/employees/import',
  // Roles & Permissions
  roles: '/app/roles',
  rolesDetail: (id: string) => `/app/roles/${id}`,
  rolesCreate: '/app/roles/create',
  // Attendance
  attendance: '/app/attendance',
  attendanceCheckIn: '/app/attendance/check-in',
  attendanceTimesheet: '/app/attendance/timesheet',
  attendanceEdit: (id: string) => `/app/attendance/${id}/edit`,
  // Schedules
  schedules: '/app/schedules',
  schedulesCalendar: '/app/schedules/calendar',
  schedulesImport: '/app/schedules/import',
  // Shifts
  shifts: '/app/shifts',
  shiftsCreate: '/app/shifts/create',
  shiftsDetail: (id: string) => `/app/shifts/${id}`,
  // Workflow
  requests: '/app/requests',
  requestsCreate: '/app/requests/create',
  requestsDetail: (id: string) => `/app/requests/${id}`,
  // Reports
  reports: '/app/reports',
  reportsAttendance: '/app/reports/attendance',
  reportsEmployees: '/app/reports/employees',
  // Notifications
  notifications: '/app/notifications',
  // Profile
  profile: '/app/profile',
  settings: '/app/settings',
} as const;

// Admin routes (Super Admin)
export const adminRoutes = {
  login: '/admin/login',
  dashboard: '/admin/dashboard',
  // Orders
  orders: '/admin/orders',
  // package
  package: '/admin/package',
  packageDetail: (id: string) => `/admin/package/${id}`,
  packageCreate: '/admin/package/create',
  // Super Admins
  superAdmins: '/admin/super-admins',
  superAdminsDetail: (id: string) => `/admin/super-admins/${id}`,
  superAdminsCreate: '/admin/super-admins/create',
  // Customers
  customers: '/admin/customers',
  customersDetail: (id: string) => `/admin/customers/${id}`,
  // Companies
  companies: '/admin/companies',
  // Subscriptions
  subscriptions: '/admin/subscriptions',
  // Reports
  reports: '/admin/reports',
} as const;

// Lazy load components
export const PublicLayout = lazy(() => import('@shared/layouts/PublicLayout'));
export const AppLayout = lazy(() => import('@shared/layouts/AppLayout'));
export const AdminLayout = lazy(() => import('@shared/layouts/AdminLayout'));

